import labcorpService from 'services/labcorp-service';

const defaultLabcorp = {
  dateCollected: null,
  dateReceived: null,
  dateReported: null,
  ldlp: null,
  ldlc: null,
  hdlc: null,
  triglycerides: null,
  cholesterol: null,
  hdlp: null,
  smallLDLP: null,
  sizeLDL: null,
  glucose: null,
  bun: null,
  creatinine: null,
  egfr: null,
  bunCreatinineRatio: null,
  sodium: null,
  potassium: null,
  chloride: null,
  carbonDioxide: null,
  calcium: null,
  insulinResistance: null,
  tsh: null,
  glycA: null,
  apoB: null,
  lpa: null,
  nonHDLCholesterol: null,
  largeVLDLP: null,
  sizeVLDL: null,
  sizeHDL: null,
  a1C: null,
  hsCRP: null,
  fastingInsulin: null,
  uACR: null,
  mrn: null,
  patientId: null,
  reportId: null
}

const state = {
  labcorp: { ...defaultLabcorp }
};

const mutations = {
  "update"(state, labcorpResult) {
    state.labcorp = labcorpResult;
  },
};

const actions = {
  resetLabcorpDataToDefault({ commit }) {
    commit("update", { ...defaultLabcorp });
  },
  async getLabcorpResult({ commit }, reportId) {
    let result = await labcorpService.getLabcorpResult(reportId);
    commit("update", result.id ? result : { ...defaultLabcorp });
  },

  async generateFinalReport({ state }) {
    return await labcorpService.generateFinalReport(state.labcorp);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};